export default "__VITE_ASSET__$_R6s58s__"